// extracted by mini-css-extract-plugin
export default {"select":"LanguageSwitch_select__bSqRQ","en":"LanguageSwitch_en__ovMgH","fr":"LanguageSwitch_fr__GSElS","de":"LanguageSwitch_de__4z63G"};